import { useMutation, useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';

import { quoteBindAxios } from 'lib/quoteBind';
import { QB_RISK_ENDORSEMENTS } from 'lib/quoteBind/queryKeys';
// app
import { enqueueNotification, hideModal } from 'stores';
import * as utils from 'utils';
import { logoutAuth0 } from 'utils/auth0/auth0';

// risks
export const useCancelPolicy = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const handleError = (err) => {
    const errorParams = {
      file: 'quoteBind.queries.useCancelPolicy',
    };

    dispatch(enqueueNotification('notification.cancelPolicy.fail', 'error'));

    utils.api.handleError(err, errorParams);
    utils.api.handleUnauthorized(err, null, logoutAuth0);
  };

  const handleSuccess = (res) => {
    queryClient.setQueryData([QB_RISK_ENDORSEMENTS, res?.riskId], (oldData = []) => [...oldData, res]);

    dispatch(enqueueNotification('notification.cancelPolicy.success', 'success'));
  };

  return useMutation(
    async ({ policyId, expiryDate, cancellationReason }) => {
      dispatch(hideModal());

      if (!policyId || !expiryDate) {
        throw new Error('useCancelPolicy: id,expiryDate is required');
      }
      const date = utils.date.getStartOfDay(expiryDate);

      const { data } = await quoteBindAxios.put(`/quotes/${policyId}/cancel?expiryDate=${date}`, {
        ...(cancellationReason && { cancellationReason }),
      });

      return data;
    },
    {
      onSuccess: (res) => handleSuccess(res),
      onError: (err) => handleError(err),
      keepPreviousData: true,
    }
  );
};
